import { render, staticRenderFns } from "./CompanyFieldList.vue?vue&type=template&id=60d2e454&scoped=true&"
import script from "./CompanyFieldList.vue?vue&type=script&lang=js&"
export * from "./CompanyFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFieldList.vue?vue&type=style&index=0&id=60d2e454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2e454",
  null
  
)

export default component.exports